import React from "react";
import { cn } from "../../lib/utils/cn";

export default function ResponsiveTable({ 
  data, 
  columns, 
  renderRow, 
  renderMobileCard,
  emptyMessage = "No items found",
  className = ""
}) {
  if (!data || data.length === 0) {
    return (
      <div className="text-center text-muted-foreground py-8">
        {emptyMessage}
      </div>
    );
  }

  return (
    <>
      {/* Desktop Table View */}
      <div className="hidden md:block overflow-x-auto">
        <table className={cn("w-full text-sm", className)}>
          <thead>
            <tr className="text-left text-muted-foreground border-b">
              {columns.map((column, index) => (
                <th 
                  key={index} 
                  className={cn("py-2", column.className)}
                >
                  {column.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => renderRow(item, index))}
          </tbody>
        </table>
      </div>

      {/* Mobile Card View */}
      <div className="md:hidden space-y-4 w-full max-w-full overflow-hidden">
        {data.map((item, index) => (
          <div key={index} className="border rounded-lg p-4 bg-card w-full max-w-full overflow-hidden">
            {renderMobileCard(item, index)}
          </div>
        ))}
      </div>
    </>
  );
}
